<div class="app-table-container">
  <table mat-table matSort [dataSource]="dataSource" class="app-table app-table-hoverable">
    <!-- Customer Space Name Definition -->
    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.customer' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.customerSpaceName }}
        <ng-container *ngIf="row.source === 'Sharepoint'">- {{ row.projectName }}</ng-container>
      </td>
    </ng-container>

    <!-- Title Definition -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.title.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.source !== 'Sharepoint'; then taskLink; else sharePointLink" />
        <ng-template #taskLink>
          <a [routerLink]="['/', 'customer-spaces', row.parentId, 'fiduciary', 'tasks', row.id]" class="cell-link">
            <app-task-table-item-title
              [taskTitle]="row.title"
              [taskSource]="row.source"
              [matTooltip]="row.title"
              matTooltipPosition="after"
            />
          </a>
        </ng-template>
        <ng-template #sharePointLink>
          <a [href]="row.sharePointTaskUrl" target="_blank" rel="noopener noreferrer" class="cell-link">
            <app-task-table-item-title
              [taskTitle]="row.title"
              [taskSource]="row.source"
              [matTooltip]="row.title"
              matTooltipPosition="after"
            />
          </a>
        </ng-template>
      </td>
    </ng-container>

    <!-- Status Definition -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.status.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.status !== '' ? getTranslatedStatus(row) : ('FIDUCIARY.tasks.columns.status.empty' | translate) }}
      </td>
    </ng-container>

    <!-- DueOn Definition -->
    <ng-container matColumnDef="dueOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.due-on' | translate }}
      </th>
      <td mat-cell *matCellDef="let row" [ngClass]="{ overdue: isOverdue(row) }">{{ row.dueOn | date }}</td>
    </ng-container>

    <!-- CreatedOn Definition -->
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.created-on' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.createdOn | date }}</td>
    </ng-container>

    <!-- CreatedBy Definition -->
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.created-by' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <span [matTooltip]="row.createdBy.name" matTooltipPosition="after">
          {{ row.createdBy.name }}
        </span>
      </td>
    </ng-container>

    <!-- AssignedTo Definition -->
    <ng-container matColumnDef="assignedTo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.assigned-to' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ getAssignedNames(row.assignees) }}</td>
    </ng-container>

    <!-- Priority Definition -->
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'FIDUCIARY.tasks.columns.priority' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-icon
          *ngIf="row.priority === 'High'"
          svgIcon="prio"
          [matTooltip]="'FIDUCIARY.tasks.high-priority' | translate"
          matTooltipPosition="after"
        ></mat-icon>
      </td>
    </ng-container>

    <!-- Header and Row Declarations -->
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>

<app-empty-list *ngIf="dataSource.filteredData.length === 0" [text]="'FIDUCIARY.tasks.empty-list' | translate" />

<mat-paginator [pageSizeOptions]="[50, 100, 500, 1000, 5000]" />
